import { createActions } from 'redux-actions';

import { ENDPOINTS_COMPETITIONS } from '../config';
import { BaseConsultantData } from '../reducers/ConsultantReducer/ConsultantReducer.types';
import { defaultErrorMessage, globalFetch, isAction } from '../shared/helpers/fetch-helper';
import { logErrorService } from '../shared/services';

export const { responseConsultantSuccess, requestConsultant, responseConsultantFailure } = createActions(
  {
    RESPONSE_CONSULTANT_SUCCESS: (data: BaseConsultantData) => ({ data }),
  },
  'REQUEST_CONSULTANT',
  'RESPONSE_CONSULTANT_FAILURE'
);

export function getConsultant(user: string) {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['consultant', 'isfetching']) === true) {
      return dispatch(requestConsultant());
    }

    dispatch(requestConsultant());

    return globalFetch(
      `${ENDPOINTS_COMPETITIONS.consultant}/boards/leader${user ? `?user=${user}` : ''}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(responseConsultantFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'RESPONSE_CONSULTANT_FAILURE')) {
          return json;
        } else if ((json as BaseConsultantData).dateStarted === undefined) {
          return dispatch(responseConsultantFailure());
        } else {
          return dispatch(responseConsultantSuccess(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(responseConsultantFailure());
      });
  };
}
